import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { HelpersService } from './helpers.service';
import { Observable, throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class CollectionsService {
  private apiURL: string = '';
  private apiURLNew: string = '';
  private apiKey: string = '';
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.apiURLNew = this.appConfig.getEnvironmentNew().url;
    this.apiKey = this.appConfig.getApiKey();
    this.env = this.appConfig.getEnvironmentNew();
  }

  getCollections(fromDate, toDate, partners) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.env.url}/Bikeshop/Collections/${this.helpersService.getPartnerId()}/Bookings?code=${this.env.key}&FromDate=${fromDate}&ToDate=${toDate}&Partners=${partners}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getDropOffs(fromDate, toDate, partners) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.env.url}/Bikeshop/Deliveries/${this.helpersService.getPartnerId()}/Bookings?code=${this.env.key}&FromDate=${fromDate}&ToDate=${toDate}&Partners=${partners}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  putCollected(serviceID, collected) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/Bikeshop/Collections/${serviceID}/${collected}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  putDroppedOff(serviceID, droppedOff) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/Bikeshop/Deliveries/${serviceID}/${droppedOff}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getDropOffDetails(jobCard, partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/V1/Delivery/${jobCard}/${partnerID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getAddressOptions(address, location) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/Athlete/V2/Address/Options?code=${this.env.key}&Address=${address}&Location=${location}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return JSON.parse(res);
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getLocationFromAddress(address) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/Athlete/Location?code=${this.env.key}&Address=${address}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getGooglePlaceInfo(placeID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/Athlete/Address/Details?code=${this.env.key}&PlaceID=${placeID}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getServiceJobCard(serviceID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/Services/Jobcards?code=${this.env.key}&ServiceID=${serviceID}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getServiceJobCardNoAuth(serviceID) {
    return this.http
      .get(
        `${this.apiURLNew}/Service/Jobcard/${serviceID}?code=${this.env.key}`,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  cancelDropOff(serviceID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        `${this.apiURLNew}/Delivery/Cancel/${serviceID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateDeliveryAddress(serviceID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        `${this.apiURLNew}/V2/Services/${serviceID}/DeliveryAddress/Update?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  checkAddressInRange(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        `${this.apiURLNew}/Bikeshop/Collections/App/CheckAddress?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getCollectionsAvailability(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        `${this.apiURLNew}/Bikeshop/Collections/App/AvailableCollectionDates?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  postDropOffInfo(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.apiURLNew + `/Delivery/Update?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateJobCardCollectionIndo(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.apiURLNew + `/Portal/JobCardCollections?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getServiceAvailability(
    partnerID,
    collectionDate,
    technicianID,
    serviceTypes,
  ) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.apiURLNew +
          `/Bikeshop/Availability/${partnerID}/Services?CollectionDate=${collectionDate}&ServiceTypes=${serviceTypes}&TechnicianID=${technicianID}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }


  //Rentals

  getRentalDeliveries(fromDate, toDate, partners) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.env.url}/Rentals/Deliveries/${this.helpersService.getPartnerId()}/Bookings?code=${this.env.key}&FromDate=${fromDate}&ToDate=${toDate}&Partners=${partners}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalCollections(fromDate, toDate, partners) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.env.url}/Rentals/Collections/${this.helpersService.getPartnerId()}/Bookings?code=${this.env.key}&FromDate=${fromDate}&ToDate=${toDate}&Partners=${partners}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalCollectionStatus(reservationID, collected) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/Rentals/Collections/${reservationID}/${collected}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalDeliveryStatus(reservationID, droppedOff) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/Rentals/Deliveries/${reservationID}/${droppedOff}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
  
  checkRentalAddressInRange(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        `${this.apiURLNew}/Rentals/Deliveries/CheckAddress?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
}
